<script>
import Loader from "./Loader";

export default {
  props: {
    title: {
      type: String,
      required: true
    },
    message: {
      type: String,
      required: true
    },
    gif: {
      type: String,
      required: false,
      default: "squeegee"
    }
  },
  components: {
    Loader
  }
};
</script>

<template>
  <section>
    <div class="ec-box">
      <loader :gif="gif" />
      <p class="ec-title">
        <b v-html="title"></b>
      </p>
      <p class="ec-message" v-html="message"></p>
      <p class="ec-message muted">Isto poderá demorar um pouco</p>
    </div>
  </section>
</template>

<style scoped>
section {
  position: fixed;
  z-index: 9999;
  left: 0;
  top: 0;
  width: 100%;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.8);
  display: flex;
  align-items: center;
  justify-content: center;
}

.ec-box {
  width: 300px;
  background-color: #fff;
  border-radius: 4px;
  padding: 50px 40px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
}

.ec-message {
  font-size: 14px;
}

.muted {
  color: #bbb;
  font-style: italic;
  font-size: 12px;
}

p {
  margin: 10px 0 0 0;
}

@media (max-width: 480px) {
  .ec-box {
    padding: 40px 30px;
    width: calc(100% - 100px);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/_Shared/Preloader/Index.vue